import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import {SUPPORTED_DATA_TYPES} from './constants'

export const pack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    if (!component.data?.label) {
        return
    }

    const {label, type} = component.data
    if (!type || !SUPPORTED_DATA_TYPES.has(type)) {
        return
    }

    component.label = label
    delete component.data.label
}
